angular.module('bmsApp.merrymaids.cis', [])
	.config([
		'$stateProvider',
		function config($stateProvider) {

			$stateProvider

				.state('main.merrymaids.cis.save', {
					url: '^/merrymaids/cis',
					views: {
						'content@main.merrymaids.cis': {
							templateUrl: 'ng/merrymaids/cis/templates/MMCisSave.html',
							controller: 'MMCisSaveCtrl'
						},
						'side@main.merrymaids.cis': {
							templateUrl: 'ng/merrymaids/cis/templates/MMCisSide.html'
						},
					},
                    ncyBreadcrumb: {label: 'CIS Input Data'}
                })

				.state('main.merrymaids.cis', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/merrymaids/cis/templates/MMCisMain.html'
						}
					}
				})
			;

		}
	]);